<script setup lang="ts">
import { AppStandardModal, AppPortableText } from '@libs/ui';

import type { DisneylandCampaignModalData } from '../../core/models/DisneylandCampaign';

interface DisneylandCampaignModalProps {
  modalData: DisneylandCampaignModalData;
}
const props = defineProps<DisneylandCampaignModalProps>();
interface DisneylandCampaignModalEmits {
  (event: 'close'): void;
}
const emit = defineEmits<DisneylandCampaignModalEmits>();
</script>

<template>
  <AppStandardModal @close="emit('close')">
    <template #title>{{ props.modalData.title }}</template>
    <template #body>
      <span class="content">
        {{ props.modalData.content }}
      </span>
      <div v-if="props.modalData.description">
        <AppPortableText
          :portable-text="props.modalData.description"
          type="disneyland-campaign-modal"
        />
      </div>
    </template>
  </AppStandardModal>
</template>

<style lang="scss">
.content {
  @include font-body-m-light;
}
</style>
